import { QueryKeys } from "../queryKeys";
import { useQueryState } from "../useQueryState";
import { useServiceTemplateApi } from "../../useServiceTemplateApi";
export const useActiveServiceTemplates = function useActiveServiceTemplates() {
  let {
    refreshOnMount
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const serviceTemplateApi = useServiceTemplateApi();
  const {
    data: serviceTemplates,
    isLoading,
    isBackgroundLoading,
    isFetching,
    error,
    refresh
  } = useQueryState({
    queryKey: [QueryKeys.ActiveServices],
    queryFn: () => serviceTemplateApi.getActiveServices(),
    refreshOnMount
  });
  return {
    serviceTemplates,
    isLoading,
    isBackgroundLoading,
    isFetching,
    error,
    refresh
  };
};